import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import { BACKEND_URL } from "@/lib/backendUrl";

const API = `${BACKEND_URL}/api`;
const EMPTY_FIELDS = { customer: "", phone: "", vehicle: "", plate: "", paintCode: "" };

const vehicleFields = (v) => ({ vehicle: v?.make_model || "", plate: v?.plate || "", paintCode: v?.paint_code || "" });

// Loads a customer from ?customer=&vehicle= and keeps the editable quote header fields
// keepFields: when editing a saved draft the quote's own header fields win over the customer record
export function useLinkedCustomer(customerId, vehicleId, { keepFields = false } = {}) {
  const [linked, setLinked] = useState(null);
  const [linkedVehicle, setLinkedVehicle] = useState(null);
  const [fields, setFields] = useState(EMPTY_FIELDS);

  useEffect(() => {
    if (!customerId) {
      setLinked(null);
      setLinkedVehicle(null);
      return;
    }
    axios.get(`${API}/customers/${customerId}`).then(({ data }) => {
      const v = data.vehicles.find((x) => x.id === vehicleId) || data.vehicles[0] || null;
      setLinked(data);
      setLinkedVehicle(v);
      if (!keepFields) setFields({ customer: data.name, phone: data.phone, ...vehicleFields(v) });
    }).catch(() => toast.error("Customer not found"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerId, vehicleId]);

  const pickVehicle = (v) => {
    setLinkedVehicle(v);
    setFields((f) => ({ ...f, ...vehicleFields(v) }));
  };

  const setField = (key, value) => setFields((f) => ({ ...f, [key]: value }));
  const clearFields = () => setFields(EMPTY_FIELDS);

  return { linked, linkedVehicle, fields, setField, setFields, pickVehicle, clearFields };
}
